import { api } from '../apiClient';

export const usersAPI = {
  signup: (email: string, password: string, customerCode?: string, name?: string, customerName?: string) => {
    return api.post('/users/signup', { email, password, customer_code: customerCode, name, customer_name: customerName });
  },
  
  checkEmail: (email: string) => {
    return api.get(`/users/check-email/${encodeURIComponent(email)}`).then(response => response.data);
  },
  
  sendVerificationCode: (email: string) => {
    return api.post('/users/send-verification-code', { email }).then(response => response.data);
  },
  
  verifyEmailCode: (email: string, code: string) => {
    return api.post('/users/verify-email-code', { email, code }).then(response => response.data);
  },
  
  getUsers: (customerId: number) => {
    return api.get(`/users?customer_id=${customerId}`).then(response => response.data);
  },
  
  approveUser: (userId: number, customerId?: number, customerName?: string) => {
    const body: any = {};
    if (customerId) {
      body.customer_id = customerId;
    }
    if (customerName) {
      body.customer_name = customerName;
    }
    return api.patch(`/users/${userId}/approve`, Object.keys(body).length > 0 ? body : undefined);
  },
  
  // INVITED 사용자 임시 비밀번호 설정 + 초대 메일 재발송
  updateAndResendInvitation: (userId: number, mode: 'manual' | 'random', manualPassword?: string) => {
    return api
      .post(`/admin/users/${userId}/invitation/update-and-resend`, {
        mode,
        manual_password: manualPassword,
      })
      .then(response => response.data);
  },
  
  deactivateUser: (userId: number) => {
    return api.patch(`/users/${userId}/deactivate`);
  }
};

